import layout from '@/layout'

export default {
  path: '/shareholders',
  component: layout,
  redirect: '/shareholders/num10',
  name: 'shareholdersNumTen',
  meta: {
    title: 'shareholders',
    icon: 'shareholders'
  },
  children: [
    {
      path: '/shareholders/num10',
      name: 'shareholdersNumTen',
      component: () => import('@/views/shareholders/shareholders-10-num'),
      meta: {
        title: 'shareholdersNumTen',
        icon: 'shareholders'
      }
    }
  ]
}
